import { render, staticRenderFns } from "./ZendeskHelp.vue?vue&type=template&id=1e8b81a2&scoped=true&"
import script from "./ZendeskHelp.vue?vue&type=script&lang=ts&"
export * from "./ZendeskHelp.vue?vue&type=script&lang=ts&"
import style0 from "./ZendeskHelp.vue?vue&type=style&index=0&id=1e8b81a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b81a2",
  null
  
)

export default component.exports